<template>
  <section class="temple-intro__guide">
    <h2>
      導覽動線建議
    </h2>
    <p>
      <img
        :src="guideImageSrc"
        :alt="`${templeName}的導覽位置圖`"
        :title="`${templeName}的導覽位置圖`"
        class="temple-intro__guide__image-content"
        @click="expandFullPhoto(guideImageSrc, `${templeName}的導覽位置圖`)"
      />
    </p>

    <Lightbox
      :isPhotoExpanded="isPhotoExpanded"
      :isCurrentPhotoLoaded="isCurrentPhotoLoaded"
      :currentPhoto="currentPhoto"
      @update:currentPhotoLoaded="isCurrentPhotoLoaded = $event"
      @update:photoExpanded="isPhotoExpanded = $event"
      @update:currentPhoto="currentPhoto = $event"
    />
  </section>
</template>

<script>
import Lightbox from '@/components/Lightbox';

export default {
  name: 'TempleGuideImage',
  props: {
    guideImageSrc: {
      type: String,
      default: '',
    },
    templeName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isPhotoExpanded: false,
      currentPhoto: {},
      isCurrentPhotoLoaded: null,
    };
  },
  computed: {},
  methods: {
    expandFullPhoto(image_url, description) {
      this.isPhotoExpanded = true;
      this.currentPhoto.image_url = image_url;
      this.currentPhoto.description = description;
    },
  },
  components: {
    Lightbox,
  },
};
</script>

<style lang="scss" scoped>
.temple-intro {
  &__guide {
    text-align: center;

    h2 {
      font-family: $title-font-family;
      font-size: 1.75rem;
      letter-spacing: 2px;
      font-weight: 600;
      color: $color-light-title;
      margin-bottom: 0.5rem;
    }

    p {
      margin: 0;
    }

    &__image-title {
      max-width: 100%;
      width: 178px;
      margin-bottom: 15px;
    }
    &__image-content {
      cursor: pointer;
    }
  }
}
</style>
